import * as yup from 'yup';
import { MAX_CHARS_IN_PHONE, MIN_CHARS_IN_PHONE, USER_AFFILIATION_OPTIONS } from '@/constants';
import { EMAIL_REGEX, PHONE_REGEX } from '@/constants/stringVars';

export const rosterUsersSchema = yup
  .object()
  .shape({
    rosterUsers: yup
      .array()
      .of(
        yup.object().shape({
          'First Name': yup.string().required('First Name is required.'),
          'Last Name': yup.string().required('Last Name is required.'),
          Email: yup.string().required('Email is required.').matches(EMAIL_REGEX, 'Wrong email format.'),
          Phone: yup
            .string()
            .required('Phone is required')
            .min(MIN_CHARS_IN_PHONE, `Minimum ${MIN_CHARS_IN_PHONE} digits required`)
            .max(MAX_CHARS_IN_PHONE, `Maximum ${MAX_CHARS_IN_PHONE} digits allowed`)
            .matches(PHONE_REGEX, 'Must be a phone number'),
          Affiliation: yup
            .string()
            .required('Affiliation is required')
            .lowercase()
            .oneOf(USER_AFFILIATION_OPTIONS as unknown as string[], 'Invalid Affiliation'),
          'Peer Support': yup.boolean().required(''),
        }),
      )
      .min(1, 'At least 1 member is required'),
  })
  .required();
